import { useFormik } from "formik";
import BoardTextInput from "../../../../components/inputs/dashboardTextInput";
import BoardButton from "../../../../components/buttons/boardButton";
import BoardSelect from "../../../../components/select/dashboardSelect";

const EditInfo = ({ t }) => {
  const formik = useFormik({
    initialValues: {},
    onSubmit: (values) => {
      console.log(values);
    },
  });

  const handleCancel = () => {
    formik.resetForm();
  };

  const shipmentType = [
    { label: t("fullLand"), value: "fullLand" },
    { label: t("partialLand"), value: "partialLand" },
    { label: t("fullSea"), value: "fullSea" },
    { label: t("partialSea"), value: "partialSea" },
    { label: t("Roro"), value: "Roro" },
    { label: t("partialAir"), value: "partialAir" },
    { label: t("Domestic"), value: "domestic" },
  ];

  return (
    <form onSubmit={formik.handleSubmit} className="text-black dark:text-white">
      <BoardSelect
        formik={formik}
        label={t("shippingType")}
        name="name"
        options={shipmentType}
        placeholder={t("shippingType")}
      />
      <BoardTextInput formik={formik} label={t("originalPrice")} name="basePrice" />
      <BoardTextInput
        formik={formik}
        label={t("pricePerExtraKilo")}
        name="extraKiloPrice"
      />
      <BoardTextInput formik={formik} label={t("maxWeight")} name="maxWeight" />

      <div className="flex flex-wrap mx-auto items-center md:flex-nowrap max-w-[600px] gap-4">
        <BoardButton
          type="button"
          onClick={handleCancel}
          secondary
          bg
          className="w-full"
        >
          {t("cancel")}
        </BoardButton>
        <BoardButton type="submit" primary bg className="w-full">
          {t("save")}
        </BoardButton>
      </div>
    </form>
  );
};

export default EditInfo;
